/* src/app/modules/shared/components/reaction/reaction.component.scss */
.my-vote {
  background-color: #d81e05;
  color: white;
}
::ng-deep .custom-tooltip {
  white-space: pre-line;
}
.react {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.react__spacer {
  flex: 1;
}
.article-icons {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 2px;
}
.article-icons img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.article-icons .vote-count {
  margin-left: 4px;
  font-size: 13px;
  font-weight: 500;
}
.react-btn {
  flex-shrink: 0;
}
.react-btn--voted {
  background: #d81e05;
  color: white;
}
.react-btn__img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
::ng-deep .mat-mdc-menu-panel .vote-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  vertical-align: middle;
  margin-right: 8px;
}
::ng-deep .mat-mdc-menu-panel button[mat-menu-item] {
  display: flex;
  align-items: center;
}
.comment-icons {
  cursor: pointer;
  position: absolute;
  right: 10px;
  bottom: 2px;
  background-color: #eeeef2;
  color: rgb(42, 32, 29);
  padding: 5px;
  border-radius: 10px;
  padding-bottom: 4px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}
.comment-icons img {
  margin-left: -5px;
}
.comment-icons .vote-count {
  font-size: small;
  margin-left: 5px;
}
.comment-actions {
  display: flex;
}
.comment-actions .action-button {
  color: #d81e05;
}
.comment-actions .dot-seperator {
  background-color: rgb(214, 214, 214);
  border-radius: 4px;
  height: 4px;
  width: 4px;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
}
.comment-actions .time {
  font-size: small;
}
.comment-actions .voted {
  font-weight: bold;
}
/*# sourceMappingURL=reaction.component.css.map */
